export enum VoteTypeEnum {
  UP = "UP",
  DOWN = "DOWN",
  FAV = "FAV",
}
